export function dealPromiseData(dataPromise, tabel, callback) {
    dataPromise.then((() => {
        callback(), tabel.scenegraph.updateNextFrame();
    })).catch((err => {}));
}
//# sourceMappingURL=deal-promise-data.js.map
